import type { AccountMedication as ApiAccountMedication } from "@tandemdiabetes/sugarmate-api-react-client"
import type { AccountMedication } from "src/types"

export function transformAccountMedication(accountMedication: ApiAccountMedication): AccountMedication {
  const {
    id,
    med_id,
    deleted,
    ...otherProps
  } = accountMedication

  return {
    ...otherProps,
    id: `${id}`,
    med_id: med_id === null ? null : `${med_id}`,
    is_deleted: !!deleted,
  }
}
